//Aplicando classe ""show-label" inputs checkout
document.addEventListener('DOMContentLoaded', function() {
    var inputs = document.querySelectorAll('.woocommerce-billing-fields__field-wrapper input, .woocommerce-billing-fields__field-wrapper select');
    inputs.forEach(function(input) {
        if (input.value) {
            input.closest('p').classList.add('show-label');
        }
 
        input.addEventListener('focus', function() {
            this.closest('p').classList.add('show-label');
        });
        input.addEventListener('blur', function() {
            if (!this.value) {
                this.closest('p').classList.remove('show-label');
            }
        });
 
        if (input.tagName === 'SELECT') {
            input.addEventListener('change', function() {
                if (this.value) {
                    this.closest('p').classList.add('show-label');
                } else {
                    this.closest('p').classList.remove('show-label');
                }
            });
        }
    });
});

//Aplicando classe ""show-label" inputs Pagemnto cartão de credito Ebanx
function initializeInputs() {
    var inputs = document.querySelectorAll('#ebanx-container-new-credit-card input, #ebanx-container-new-credit-card select');

    inputs.forEach(function(input) {
        if (input.value) {
            input.closest('.ebanx-form-row').classList.add('show-label');
        }

        input.addEventListener('focus', function() {
            this.closest('.ebanx-form-row').classList.add('show-label');
        });

        input.addEventListener('blur', function() {
            if (!this.value) {
                this.closest('.ebanx-form-row').classList.remove('show-label');
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    initializeInputs();
    
    jQuery(document.body).on('updated_checkout', function() {
        initializeInputs();
    });
});